module.exports = __webpack_public_path__ + "img/Asset 1@2x.97fccf96.png";